module.exports = __webpack_public_path__ + "img/tingedu-logo-horizontal.ee986b6f.png";